import React, { FC, useState } from 'react'
import ReactStars from 'react-rating-stars-component'
import { COLORS } from 'src/styles/theme'
import { SvgIcon } from '../shared/SvgIcon'
import { SvgType } from '../shared/SvgIcon/SvgIcon'
import { StarRatingStyle } from './styled'

const DEFAULT_ACTIVE_COLOR = COLORS.accent
const DEFAULT_COLOR = '#e2e2e2'

interface StarRatingProps {
  handleSubmit: (rating: number) => void
  title?: string
  totalStars?: number
  activeColor?: string
  defaultColor?: string
}

export const StarRating: FC<StarRatingProps> = ({ handleSubmit, title, totalStars = 5, defaultColor = DEFAULT_COLOR, activeColor = DEFAULT_ACTIVE_COLOR }) => {
  const [showStars, setShowStars] = useState(title ? false : true)

  return (
    <StarRatingStyle activeColor={activeColor} defaultColor={defaultColor}>
      {showStars ? (
        <div className="starsContainer">
          <ReactStars
            count={totalStars}
            onChange={handleSubmit}
            emptyIcon={<SvgIcon type={SvgType.STAR_EMPTY} />}
            filledIcon={<SvgIcon type={SvgType.STAR_FILLED} className="filledStar" />}
          />
          <p>Submit Rating</p>
        </div>
      ) : (
        <button className="titleContainer" onClick={() => setShowStars(true)}>
          <SvgIcon type={SvgType.THUMBS_UP} />
          <div className="title">{title}</div>
        </button>
      )}
    </StarRatingStyle>
  )
}
